module.exports = __webpack_public_path__ + "img/img-1.2678603a.png";